// Angular imports
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

// RxJs imports
import { Subscription } from 'rxjs';

// Component imports
import { BaseComponent } from '../../_base/rp-base-component';

// Service imports
import { AuthService } from '../../_services/auth.service';
import { ScreenService } from '../../_services/shared-services/screen.service';
import { AppInfoService } from '../../_services/app-info.service';
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { UserPropertyResultDto } from '../../_models/user-property-result-dto';
import { BrandingConfigurationResultDto } from '../../_models/branding-configuration-result-dto';

// Constant imports
import { ImageConstants } from '../../_constants/image-constants';

// CC-Common imports
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-branding-image',
  templateUrl: './branding-image.component.html',
  styleUrls: ['./branding-image.component.scss'],
  standalone: false
})
export class BrandingImageComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  logoImage: string = ImageConstants.ccLogo;
  logoLocation: string = 'before';

  title: string;
  brandImage: SafeUrl;
  brandAltText: string;

  isSmallScreen: boolean;
  isInternalUser: boolean = false;
  selectedProperty: UserPropertyResultDto;
  propertyChangeSubscription: Subscription;

  constructor(
    private authService: AuthService,
    screenService: ScreenService,
    private appInfoService: AppInfoService,
    private userService: UserService,
    private sanitizer: DomSanitizer
  ) {
    super(screenService);
  }

  ngOnInit() {
    this.title = this.appInfoService.title;
    this.isInternalUser = this.userService.isInternal();
    this.brandImage = null;

    this.updateScreenSize();
    RxjsUtils.safeSubscribe(this.screenService.changed, () =>
      this.updateScreenSize()
    );

    RxjsUtils.subscribeToSubject(
      this.userService.getSubjectImpersonateChanged(),
      () => {
        this.isInternalUser = this.userService.isInternal();
        this.brandImage = null;
      }
    );

    this.propertyChangeSubscription = RxjsUtils.subscribeToSubject(
      this.userService.getSubjectPropertySelectionChanged(),
      () => {
        const selectedProperty = this.userService.getSelectedProperty();
        if (!!selectedProperty && !!selectedProperty.communityId) {
          if (
            !this.selectedProperty ||
            this.selectedProperty.communityId !== selectedProperty.communityId
          ) {
            this.selectedProperty = selectedProperty;
            this.populateBrandingInformation(selectedProperty.communityId);
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (!!this.propertyChangeSubscription) {
      this.propertyChangeSubscription.unsubscribe();
    }
  }

  private updateScreenSize(): void {
    this.isSmallScreen = this.screenService.isSmallScreen();
  }

  private populateBrandingInformation(communityId: number): void {
    RxjsUtils.safeSubscribe(
      this.authService.getBrandingInformation(communityId),
      (data: BrandingConfigurationResultDto) => {
        /* this.selectedProperty.contactPhoneNumber = data.tollFreePhone;
            this.selectedProperty.contactPhoneText = ""; */
        this.userService.setBrandingInforamtion(data);
        this.userService.updateSubjectBrandingInforamtionChanged(data);
        this.userService.setSelectedProperty(this.selectedProperty);

        if (data.brandingImageUrl) {
          RxjsUtils.safeSubscribe(
            this.authService.getBrandingImageData(data.brandingImageUrl),
            (imageData: Blob) => {
              const imageUrl = window.URL.createObjectURL(imageData);
              this.brandImage = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
              this.brandAltText = data.taglineText;
            }
          );
        } else {
          this.brandImage = this.logoImage;
          this.brandAltText = this.title;
        }
      }
    );
  }
}
